import * as React from 'react'
import { PageContent } from '@components/pages'
import { PageContentHeader } from '@components/pages/page-content-header'
import { Paths } from '@logic'
import { EmptyState } from '@shared/components/empty-state'
import { BaseLinkProps } from '@components/navigation/navigation'

export const SystemHealthPage: React.FC<any> = () => {
  const parent: BaseLinkProps = { path: Paths.adminRoot }

  return (
    <PageContent>
      <PageContentHeader title="System Health" parent={parent} />
      <EmptyState
        title="System Health Contract"
        description="No consolidated health endpoint is mounted for this page yet. Current backend health is split across GET /api/v1/admin/gateway/health, GET /api/v1/mattermost/health, and GET /api/v1/prime/status."
      />
    </PageContent>
  )
}
